/**
 * @Page WST01
 * @Description 완성차 재고관리 > 현황관리 > 완성차 재고관리등록
 * @Table WRTWQTY 실재고 수량
 **/
import React, { useState, useEffect, useRef, useCallback } from "react";
import Ribbon from '@/components/organisms/Ribbon';
import GridRibbon from "@/components/organisms/GridRibbon";
import ContentXearch from '@/components/organisms/ContentXearch';
import Content from '@/components/organisms/Content';
import Grid from '@/components/grid/agGrid';
import CustomAlert from "@/components/molecules/CustomAlert";
import AlertDialog from '@/components/material-UI/AlertDialog';
import * as Common from '@/utils/Common';
import CommonUtil from '@/utils/CommonUtil';

const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER;
const Utils = new CommonUtil();

function WST01() {
    const token = Common.getToken();
    const tVnt1 = Common.getToken("vand");
    const tComp = Common.getToken("comp");

    const grdWST01 = useRef();

    // ─── 상태 ────────────────────────────────────────────────────────────
    const [idata, setData] = useState({
        kVnt1: tVnt1,           // 로그인 업체코드
        kComp: tComp,
        kWrcd: "",              // 창고코드
        kStdt: Common.getToday(), // 일자
        kOrdr: "",              // 차수
        kRecd: "",              // 상주원
        kGrtp: "",              // 품번그룹
        kPtno: "",              // 품번

        // 콤보 목록
        wrcdList: [],           // 창고코드 목록
        grptList: [],           // 품번그룹 목록
        ordrList: [],           // 차수 목록
        recdList: [],           // 상주원 목록
    });

    const [message, setMessage] = useState({ openAlert: false, severity: "success", msg: "" });
    const { openAlert, severity, msg } = message;

    const [dlgMessage, setDlgMessage] = useState({ openDlg: false, dlgTrans: "", dlgMsg: "" });
    const { openDlg, dlgTrans, dlgMsg } = dlgMessage;

    let [searchApi, setSearchApi] = useState(false);
    let [insertApi, setInsertApi] = useState(false);
    let [deleteApi, setDeleteApi] = useState(false);

    const [panded, setPanded] = useState(true);
    const [style, setStyle] = useState({ height: "calc(100vh - 65px - 35px - 50px - 21px - 56px - 8px)" });

    const onClearApi = useCallback(async () => {
        setSearchApi(false);
        setInsertApi(false);
        setDeleteApi(false);
    }, []);

    // ─── Mount ───────────────────────────────────────────────────────────
    useEffect(() => {
        onSearchWrcdList();
        onSearchOrdrList();
        onSearchGrptList();
        onSearchRecdList();
        onSearch();
    }, []);

    // 창고코드 목록 조회
    const onSearchWrcdList = async () => {
        // 완성차 재고관리 신규 입력 화면에는 사용 중인 창고만 노출한다.
        const para = `{"kVnt1":"${tVnt1}","kWrcd":"","wareyn":"Y"}`;
        const param = encodeURI(para);
        const query = SERVER_URL + "/rst01/ware/search?query=" + param;
        await fetch(query, { headers: { Authorization: token } })
            .then(resp => resp.json())
            .then(data => {
                if (data.success && data.data) {
                    const list = [{ comCode: "", text: "전체" },
                        ...data.data.map(w => ({ comCode: w.wrcd, text: `${w.wrcd} - ${w.wrnm}` }))];
                    setData(prev => ({ ...prev, wrcdList: list }));
                }
            })
            .catch(() => {});
    };

    // 선택한 창고의 차수 목록 조회 (창고 미선택 시 업체 전체 차수)
    const onSearchOrdrList = async (wrcd = "") => {
        const para = `{"wrcd":"${wrcd}","ordryn":"Y"}`;
        const param = encodeURI(para);
        const query = SERVER_URL + "/rst01/ordr/search?query=" + param;
        await fetch(query, { headers: { Authorization: token } })
            .then(resp => resp.json())
            .then(data => {
                if (data.success && data.data) {
                    const uniqueOrders = [...new Map(data.data.map(o => [o.ordr, o])).values()]
                        .sort((a, b) => String(a.ordr).localeCompare(String(b.ordr), undefined, { numeric: true }));
                    const list = [{ comCode: "", text: "전체" },
                        ...uniqueOrders.map(o => ({
                            comCode: o.ordr,
                            text: wrcd && o.etc ? `${o.ordr}차수 - ${o.etc}` : `${o.ordr}차수`,
                        }))];
                    setData(prev => ({ ...prev, ordrList: list }));
                }
            })
            .catch(() => {});
    };

    // 품번그룹 목록 조회
    const onSearchGrptList = async () => {
        const para = `{"kVnt1":"${tVnt1}","kGrtp":"","kGryn":"*"}`;
        const param = encodeURI(para);
        const query = SERVER_URL + "/rst03/wagr/search?query=" + param;
        await fetch(query, { headers: { Authorization: token } })
            .then(resp => resp.json())
            .then(data => {
                if (data.success && data.data) {
                    const list = [{ comCode: "", text: "전체" },
                        ...data.data.map(g => ({ comCode: g.grtp, text: `${g.grtp} - ${g.grnm}` }))];
                    setData(prev => ({ ...prev, grptList: list }));
                }
            })
            .catch(() => {});
    };

    // 상주원 목록 조회
    const onSearchRecdList = async () => {
        const para = `{"kVnt1":"${tVnt1}","recd":"","useyn":"*"}`;
        const param = encodeURI(para);
        const query = SERVER_URL + "/rst02/resi/search?query=" + param;
        await fetch(query, { headers: { Authorization: token } })
            .then(resp => resp.json())
            .then(data => {
                if (data.success && data.data) {
                    const list = [{ comCode: "", text: "전체" },
                        ...data.data.map(r => ({
                            comCode: r.recd,
                            text: `${r.recd} - ${r.renm}${r.useyn === "N" ? " [미사용]" : ""}`,
                        }))];
                    setData(prev => ({ ...prev, recdList: list }));
                }
            })
            .catch(() => {});
    };

    // ─── Control 변경 ────────────────────────────────────────────────────
    const onChange = async (e) => {
        const { name, value } = e.target;
        if (name === "kWrcd") {
            setData(prev => ({ ...prev, kWrcd: value, kOrdr: "" }));
            await onSearchOrdrList(value);
            return;
        }
        setData(prev => ({ ...prev, [name]: value }));
    };

    // ─── 조회 ─────────────────────────────────────────────────────────────
    const onSearch = async () => {
        const stdt = idata.kStdt ? idata.kStdt.replace(/-/g, "") : "";
        const ptno = idata.kPtno ? idata.kPtno.replace(/-/g, "") : "";
        const para = `{"kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}","wrcd":"${idata.kWrcd}","stdt":"${stdt}","ordr":"${idata.kOrdr}","recd":"${idata.kRecd}","grpt":"${idata.kGrtp}","ptno":"${ptno}"}`;
        const param = encodeURI(para);
        const query = SERVER_URL + "/wst01/qty/search?query=" + param;
        setSearchApi(query);
    };

    const onSearchKeyDown = (e) => {
        if (e.key === "Enter" && ["INPUT", "SELECT"].includes(e.target.tagName)) {
            e.preventDefault();
            onSearch();
        }
    };

    // ─── 신규 Row 추가 ────────────────────────────────────────────────────
    const onAddRow = async () => {
        const stdt = idata.kStdt ? idata.kStdt.replace(/-/g, "") : Common.getToday().replace(/-/g, "");
        const newItems = {
            vand: idata.kVnt1,
            wrcd: idata.kWrcd,
            stdt: stdt,
            ordr: idata.kOrdr,
            grpt: idata.kGrtp,
            ptno: idata.kPtno,
            waqt: "",
            etc:  "",
            gocd: "ADD",
        };
        grdWST01.current.addRow(newItems, 0);
    };

    // ─── 저장 (Insert/Update) ─────────────────────────────────────────────
    const onInsert = async () => {
        const selectedData = grdWST01.current.getSelectedNodes();
        if (selectedData.length === 0) {
            setMessage({ openAlert: true, severity: "info", msg: "저장할 데이터를 선택해 주세요." });
            return;
        }
        for (const node of selectedData) {
            if (!node.data.wrcd) {
                setMessage({ openAlert: true, severity: "warning", msg: "창고코드를 입력해 주세요." });
                return;
            }
            if (!node.data.stdt) {
                setMessage({ openAlert: true, severity: "warning", msg: "일자를 입력해 주세요." });
                return;
            }
            if (!node.data.ptno) {
                setMessage({ openAlert: true, severity: "warning", msg: "품번을 입력해 주세요." });
                return;
            }
            if (!node.data.grpt) {
                setMessage({ openAlert: true, severity: "warning", msg: "품번그룹코드를 입력해 주세요." });
                return;
            }
            if (!node.data.recd) {
                setMessage({ openAlert: true, severity: "warning", msg: "상주원코드가 없는 행은 수량을 저장할 수 없습니다." });
                return;
            }
            if (node.data.waqt === "" || node.data.waqt === null || node.data.waqt === undefined) {
                setMessage({ openAlert: true, severity: "warning", msg: "수량을 입력해 주세요." });
                return;
            }
        }
        setInsertApi(SERVER_URL + "/wst01/qty/insert");
    };

    // ─── 삭제 ─────────────────────────────────────────────────────────────
    const onDelete = async () => {
        const selectedData = grdWST01.current.getSelectedNodes();
        if (selectedData.length === 0) {
            setMessage({ openAlert: true, severity: "info", msg: "삭제할 데이터를 선택해 주세요." });
            return;
        }
        setDlgMessage({ openDlg: true, dlgTrans: "D", dlgMsg: "선택한 완성차 재고관리 데이터를 삭제하시겠습니까?" });
    };

    // ─── AlertDialog 결과 ────────────────────────────────────────────────
    const AlertDialogResult = async (e) => {
        setDlgMessage({ openDlg: false, dlgTrans: "", dlgMsg: "" });
        if (e.result === "N") return;
        switch (e.Trans) {
            case "D":
                setDeleteApi(SERVER_URL + "/wst01/qty/delete");
                break;
            default:
                break;
        }
    };

    // ─── 검색조건 ────────────────────────────────────────────────────────
    const optionsX = {
        0: [
            {
                formatter: "input", name: "kStdt", labelName: "일자", type: "date",
                defaultValue: idata.kStdt, align: "left", labelType: "none",
            },
            {
                formatter: "select", name: "kWrcd", labelName: "창고코드", type: "text",
                defaultValue: idata.kWrcd, codeMode: false, selectAll: "",
                codes: idata.wrcdList, comms: null,
            },
            {
                formatter: "select", name: "kOrdr", labelName: "차수", type: "text",
                defaultValue: idata.kOrdr, codeMode: false, selectAll: "",
                codes: idata.ordrList, comms: null,
            },
            {
                formatter: "select", name: "kRecd", labelName: "상주원", type: "text",
                defaultValue: idata.kRecd, codeMode: false, selectAll: "",
                codes: idata.recdList, comms: null,
            },
            { formatter: "blank", align: "right" },
            { formatter: "blank", align: "right" },
        ],
        1: [
            {
                formatter: "select", name: "kGrtp", labelName: "품번그룹", type: "text",
                defaultValue: idata.kGrtp, codeMode: false, selectAll: "",
                codes: idata.grptList, comms: null,
            },
            {
                formatter: "input", name: "kPtno", labelName: "품번", type: "text",
                defaultValue: idata.kPtno, readOnly: false, align: "left", labelType: "none",
            },
            { formatter: "blank", align: "right" },
            { formatter: "blank", align: "right" },
            { formatter: "blank", align: "right" },
            { formatter: "blank", align: "right" },
        ],
    };

    // ─── Grid 컬럼 (WRTWQTY 기준) ─────────────────────────────────────────
    const columnDefs = [
        { headerName: "업체코드(h)", field: "vand", hide: true },
        { headerName: "회사코드(h)", field: "comp", hide: true },
        {
            headerName: "창고코드", field: "wrcd",
            sortable: true, filter: true, flex: 1, minWidth: 200,
            editable: false, cellClass: ["nocheckbox", "alignL"],
            singleClickEdit: true, hide: false,
            checkboxSelection: true, headerCheckboxSelection: true,
            valueFormatter: params => {
                const code = params.value ?? "";
                const name = params.data?.wrnm ?? "";
                return name ? `${code} (${name})` : code;
            },
        },
        {
            headerName: "공장코드", field: "plnt",
            sortable: true, filter: true, flex: 1, minWidth: 70,
            editable: false, cellClass: ["nocheckbox", "alignC"],
            singleClickEdit: false, hide: false,
            valueGetter: params => params.data?.plnt ?? params.data?.wrcplnt ?? params.data?.wdcplnt ?? params.data?.factory ?? "",
        },
        {
            //headerName: "일시", field: "stdtexample",
            headerName: "일시", field: "stdt",
            sortable: true, filter: true, flex: 1, minWidth: 80,
            editable: false,  cellClass: ["nocheckbox", "alignL"],
            singleClickEdit: true, hide: false,
            valueFormatter: params => {
                const value = String(params.value ?? "");
                return /^\d{8}$/.test(value)
                    ? `${value.slice(0, 4)}-${value.slice(4, 6)}-${value.slice(6, 8)}`
                    : value;
            },
        },
        {
            headerName: "차수", field: "ordrdisp",
            sortable: true, filter: true, flex: 1, minWidth: 140,
            editable: false,  cellClass: ["nocheckbox", "alignC"],
            singleClickEdit: true, hide: false,
        },
        {
            headerName: "품번그룹", field: "grpt",
            sortable: true, filter: true, flex: 1, minWidth: 130,
            editable: false,  cellClass: ["nocheckbox", "alignL"],
            singleClickEdit: true, hide: false,
            valueFormatter: params => {
                const code = params.value ?? "";
                const name = params.data?.grnm ?? "";
                return name ? `${code} (${name})` : code;
            },
        },
        {
            headerName: "품번", field: "ptno",
            sortable: true, filter: true, flex: 2, minWidth: 150,
            editable: false,  cellClass: ["nocheckbox", "alignL"],
            singleClickEdit: true, hide: false,
            valueGetter: Utils.partnoGetter,
        },
        {
            headerName: "수량입력상태", field: "stdtgubn2",
            sortable: true, filter: true, flex: 1, minWidth: 100,
            editable: false,  cellClass: ["nocheckbox", "alignC"],
            singleClickEdit: true, hide: false,
            valueFormatter: params => {
                if (params.value === "Y") return "입력";
                if (params.value === "N") return "미입력";
                return params.value ?? "";
            },
            cellStyle: params => params.value === "Y"
                ? { color: "rgb(78 92 217)", fontWeight: "bold", fontSize: "10px" }
                : params.value === "N"
                    ? { color: "#6e6e6e", fontWeight: "bold", fontSize: "10px" }
                    : { fontSize: "10px" },
        }, 
        {
            headerName: "수량", field: "waqt",
            sortable: true, filter: true, flex: 1, minWidth: 80,
            editable: true, headerClass: "editCell", cellClass: ["nocheckbox", "alignR"],
            singleClickEdit: true, hide: false,
            type: "numericColumn"
            //, valueFormatter: Utils.numberFormatter
            , cellStyle: params => {
                if (params.data.stdtgubn2 === "Y") {
                        return { color: "rgb(78 92 217)", fontWeight: "bold" };
                } return { color: "#6e6e6e", fontWeight: "bold" };
            }
        },
        {
            headerName: "상주원코드", field: "recd",
            sortable: true, filter: true, flex: 1, minWidth: 150,
            editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"],
            singleClickEdit: false, hide: false,
            valueFormatter: params => {
                const code = params.value ?? "";
                const name = params.data?.renm ?? "";
                return name ? `${code} (${name})` : code;
            },
        },
        {
            headerName: "비고(수량비고)", field: "etc",
            sortable: true, filter: true, flex: 2, minWidth: 500,
            editable: true, headerClass: "editCell", cellClass: ["nocheckbox", "alignL"],
            singleClickEdit: true, hide: false,
        },
    ];

    const onClick = async () => {
        setPanded(!panded);
        if (panded === true) {
            setStyle({ height: "calc(100vh - 65px - 35px - 50px - 21px - 8px)" });
        } else {
            setStyle({ height: "calc(100vh - 65px - 35px - 50px - 21px - 56px - 8px)" });
        }
    };

    return (
        <>
            {/* Dialog */}
            <AlertDialog open={openDlg} trans={dlgTrans} message={dlgMsg} onClose={AlertDialogResult} />

            {/* Alert */}
            <CustomAlert
                open={openAlert} severity={severity} duration={5000} message={msg}
                onClose={() => setMessage({ openAlert: false, severity: "", msg: "" })}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            />

            {/* Ribbon */}
            <Ribbon
                onSearch={onSearch} onSearchName={null}
                onInsert={onInsert} onInsertName={"저장"}
                // onDelete={onDelete} onDeleteName={"삭제"}
            >
                {"완성차 재고관리 > 현황관리 > "}
                <b style={{ color: "#cd5c5c", fontFamily: "PretendardMedium, NanumGothic, sans-serif" }}>
                    완성차 재고관리등록
                </b>
            </Ribbon>

            {/* 검색조건 */}
            <div onKeyDown={onSearchKeyDown}>
                <ContentXearch optionsX={optionsX} onChange={onChange} onClick={onClick} />
            </div>

            {/* Content */}
            <Content style={style}>
                <div className="grid_type01">
                    <div className="grid_wrap01">
                        <GridRibbon
                            onSearch={onSearch}   onSearchName={null}
                            onAddRow={onAddRow}   onAddRowName={"신규"}
                            onInsert={onInsert}   onInsertName={"저장"}
                            onDelete={onDelete}   onDeleteName={"삭제"}
                        />
                        <div className="grid_cont_box" style={{ height: "calc(100%)" }}>
                            <Grid
                                ref={grdWST01}
                                gridId={"WST01"}
                                columnDefs={columnDefs}
                                pagination={true}
                                paginationCsv={true}
                                paginationPageSize={"1000"}
                                rowMultiSelectWithClick={true}
                                suppressRowClickSelection={false}
                                rowSelection={"multiple"}
                                enableRangeSelection={false}
                                enableCellTextSelection={true}
                                // 창고코드 컬럼에만 체크박스를 표시하고 Grid 자동 체크박스는 사용하지 않음
                                isFirst={false}
                                displayNo={true}
                                searchApi={searchApi}
                                insertApi={insertApi}
                                deleteApi={deleteApi}
                                onClearApi={onClearApi}
                                insertRefresh={onSearch}
                                deleteRefresh={onSearch}
                                onCellValueChangedEvent={async () => {}}
                            />
                        </div>
                    </div>
                </div>
            </Content>
        </>
    );
}

export default WST01;
